import { Injectable, Injector, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DigitalCertificateRegistration } from "@vhealth/professional/digital-certificate";

@Injectable({ providedIn: "root" })
export class DigitalCertificateRegistrationService implements DigitalCertificateRegistration {
    private readonly _dialogs = inject(MatDialog);
    private readonly _injector = inject(Injector);
    private _opening = false;

    async register(): Promise<void> {
        if (this._opening || this._dialogs.getDialogById("digital-certificate-dialog")) {
            return;
        }

        this._opening = true;

        try {
            // SignatureService is imported here, not at the top, so the signature and file-manager proxies stay out of the initial bundle (VS-1954)
            const [{ DigitalCertificateDialogComponent }, { SignatureService }] = await Promise.all([
                import("./digital-certificate-dialog/digital-certificate-dialog.component"),
                import("./signature.service"),
            ]);

            this._dialogs
                .open(DigitalCertificateDialogComponent, {
                    id: "digital-certificate-dialog",
                    panelClass: "digital-certificate-dialog",
                    width: "760px",
                    maxWidth: "95vw",
                    hasBackdrop: true,
                    autoFocus: "dialog",
                })
                .afterClosed()
                .subscribe(() => this._injector.get(SignatureService).reloadActiveSignatureEngine());
        } finally {
            this._opening = false;
        }
    }
}
